import _objectSpread from "D:/wenge-Obj/zhichuan/llm-agent-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "D:/wenge-Obj/zhichuan/llm-agent-web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _typeof from "D:/wenge-Obj/zhichuan/llm-agent-web/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.is-safe-integer.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import Vue from "vue";
import Router from "vue-router";
// import { getCookies } from "@/utils/auth";
// import { getIP } from "@/utils";
import { MessageBox, Message } from "element-ui";
import router from "@/router";
import app from '../main';
import md5 from "js-md5";
import { applyAcceptLanguageHeader } from "@/utils/requestLanguage";
// getIP();
//创建一个axios
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  // withCredentials: true, // 请求头中是否携带cookie
  timeout: 180000 //请求超时
});
// 安全数字验证函数
var validateNumber = function validateNumber(value) {
  if (value === null || value === undefined) return value;

  // 检查是否为数字或可转换为数字的字符串
  if (typeof value === 'string' && /^-?\d+$/.test(value)) {
    value = parseInt(value, 10);
  }
  if (typeof value !== 'number' || isNaN(value)) {
    return value; // 非数字值原样返回
  }

  // 检查是否在安全范围内
  if (!Number.isSafeInteger(value)) {
    throw new Error("\u6570\u503C\u8D85\u51FA\u5B89\u5168\u8303\u56F4: ".concat(value));
  }
  return value;
};

// 深度遍历对象验证数字
var _sanitizeNumbers = function sanitizeNumbers(obj) {
  if (obj instanceof File || obj === null || _typeof(obj) !== 'object') {
    return obj;
  }
  for (var key in obj) {
    if (Array.isArray(obj[key])) {
      obj[key] = obj[key].map(function (item) {
        return _sanitizeNumbers(item);
      });
    } else if (_typeof(obj[key]) === 'object') {
      obj[key] = _sanitizeNumbers(obj[key]);
    } else {
      //console.log(obj)
      // obj[key] = validateNumber(obj[key]);
    }
  }
  return obj;
};
//请求拦截器
service.interceptors.request.use(function (config) {
  var _config$method;
  var timer = new Date().getTime();
  //请求发送前
  var manageAccessToken = sessionStorage.getItem('manageAccessToken');
  config.headers.Authorization = "Bearer ".concat(manageAccessToken);
  applyAcceptLanguageHeader(config, app.$i18n.locale);
  var requestData = {};
  var requestParam = '';
  // 处理 GET 参数
  if (config.method === 'get' || config.url === '/login') {
    // requestData = sanitizeNumbers({ ...config.params });
    // console.log("requestData", requestData)
    // config.params = requestData; // 更新净化后的参数
    // 处理 params 为指定格式
    if (config.params && Object.keys(config.params).length > 0) {
      // 将 params 对象转换为 key=value 的字符串格式
      var paramsString = Object.entries(config.params).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return "".concat(key, "=").concat(value);
      }).join('&');

      // console.log('转换后的 params 字符串:', paramsString);
      // 示例输出: "tenantId=1tenantId1=2"

      requestData = paramsString;
      requestParam = paramsString;
    } else {
      requestData = "";
      requestParam = "";
    }
  }

  // 处理 POST 数据
  if (['post', 'put', 'patch'].includes((_config$method = config.method) === null || _config$method === void 0 ? void 0 : _config$method.toLowerCase())) {
    if (config.data instanceof FormData) {
      // FormData 特殊处理
      var formDataObj = {};
      config.data.forEach(function (value, key) {
        formDataObj[key] = value;
      });
      requestData = _sanitizeNumbers(formDataObj);
    } else if (config.data instanceof Blob || config.data instanceof ArrayBuffer) {
      // 二进制数据不处理
      requestData = {
        binary_data: '[binary]'
      };
    } else {
      if (!Array.isArray(config.data)) {
        requestData = _sanitizeNumbers(config.data ? _objectSpread({}, config.data) : {});
        config.data = requestData; // 更新净化后的数据
      } else {
        requestData = config.data;
      }
    }
  }
  //console.log("config", config)
  config.headers.timestamp = timer;
  var paramsData = config.method === 'get' ? requestData : JSON.stringify(requestData);
  var paramsUrl = config.method === 'get' && config.url.includes('?') ? config.url.replace(/\?/, '') : config.url;
  // 安全计算 cipher
  config.headers.cipher = md5(timer + "".concat(paramsUrl).concat(paramsData).concat(requestParam, "a25vd2xlZGdlLWxvbmd5YW4="));
  //console.log("clipher参数", timer + `${paramsUrl}${paramsData}${requestParam}a25vd2xlZGdlLWxvbmd5YW4=`)
  return config;
}, function (error) {
  //请求失败
  return Promise.reject(error);
});
var __tag = 0;
var __powerTag = 0;
//响应拦截器
service.interceptors.response.use(function (response) {
  //console.log(app.$t('confirm'))
  var res = response.data;
  //依据需要调整code
  if (res.code !== 200) {
    //000024: 未登录;
    if (res.code === "000024") {
      if (__tag === 0) {
        __tag = 1;
        MessageBox.confirm("您已处于离线状态，是否返回重新登录？", app.$t('tips'), {
          confirmButtonText: app.$t('confirm'),
          customClass: "confirmClass",
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false
        }).then(function () {
          router.replace({
            name: 'login'
          });
        });
      }
      // 20013: 其他电脑登录强迫下线;
    } else if (res.code === 20013) {
      if (__tag === 0) {
        __tag = 1;
        MessageBox.confirm("当前账号已在其他电 脑登录，您已被强迫下线。是否返回重新登录？", app.$t('tips'), {
          confirmButtonText: app.$t('confirm'),
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false,
          customClass: "confirmClass"
        }).then(function () {
          router.replace({
            name: 'login'
          });
        });
      }
    } else {
      __tag = 0;
    }
    return res;
    // return Promise.reject(new Error(res.msg))
  } else {
    return res;
  }
}, function (error) {
  if (error.response && (error.response.status === 403 || error.response.status === 401) && error.message != '请求中止') {
    if (__tag === 0) {
      __tag = 1;
      MessageBox.confirm("您已处于离线状态，是否返回重新登录？", app.$t('tips'), {
        confirmButtonText: app.$t('confirm'),
        customClass: "confirmClass",
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false
      }).then(function () {
        router.replace({
          name: 'login'
        });
      });
    }
  } else {
    var style = document.createElement('style');
    style.textContent = "\n  .custom-message .el-message__closeBtn {\n    right:10px;\n    top:23px;\n  }\n";
    document.head.appendChild(style);
    Message.warning({
      message: '系统异常，请稍后重试...',
      showClose: true,
      customClass: 'custom-message'
    });
  }
  return Promise.reject(error);
});
export default service;